import React from 'react';
import { bool } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { useConfiguration } from '../../context/configurationContext';
import { Footer, H3, LayoutSingleColumn, Page } from '../../components';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import css from './AboutUsPage.module.css';
import SectionFounders from './sections/SectionFounders/SectionFounders';

export const AboutUsPageComponent = props => {
  const { intl, scrollingDisabled } = props;

  const config = useConfiguration();
  const marketplaceName = config.marketplaceName;
  const schemaTitle = intl.formatMessage({ id: 'AboutUsPage.schemaTitle' }, { marketplaceName });
  const schemaDescription = intl.formatMessage({ id: 'AboutUsPage.schemaDescription' });

  return (
    <Page
      className={css.root}
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
        description: schemaDescription,
      }}
    >
      <LayoutSingleColumn
        mainColumnClassName={css.rootBackground}
        topbar={<TopbarContainer isDark={true} currentPage="AboutUsPage" />}
        footer={<Footer />}
      >
        <div className={css.horizontalWrapper}>
          <p className={css.subtitle}>
            <FormattedMessage id="AboutUsPage.subtitle" />
          </p>
          <h1 className={css.title}>
            <FormattedMessage id="AboutUsPage.title" />
          </h1>
          <p className={css.text}>
            <FormattedMessage id="AboutUsPage.text1" />
          </p>
          <p className={css.text}>
            <FormattedMessage id="AboutUsPage.text2" />
          </p>
          <p className={css.highlitedText}>
            <FormattedMessage id="AboutUsPage.text3" />
          </p>
        </div>
        <SectionFounders intl={intl} />
      </LayoutSingleColumn>
    </Page>
  );
};

AboutUsPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const AboutUsPage = compose(
  connect(mapStateToProps),
  injectIntl
)(AboutUsPageComponent);

export default AboutUsPage;
